import { combineReducers } from 'redux';
import search from './peopleSearchReducer.js';
import fields from './fieldsReducer.js';
export default combineReducers({
  search,
  fields,
});



/** WEBPACK FOOTER **
 ** F:/agent-C107052-04/_work/420/s/Tube.Frontend/src/containers/App/screens/Tube/screens/PeopleSearch/reducers/index.js
 **/